export interface Executive {
  id: string;
  name: string;
  position: string;
  image: string;
  bio: string | string[];
  email?: string;
  linkedin?: string;
  twitter?: string;
  website?: string;
  qualifications: string[];
  responsibilities: string[];
  professionalHighlights: string[];
}

export const EXECUTIVES: Executive[] = [
  {
    id: 'president',
    name: 'Olabode G. Agboola',
    position: 'President',
    image: '/images/Olabode.jpeg',
    bio: [
      "Olabode G. Agboola is a distinguished cybersecurity and information assurance leader with over 25 years of progressive experience shaping national and corporate cybersecurity strategies across critical sectors. He plays a pivotal role in driving policy engagement, industry collaboration, and public awareness initiatives aimed at strengthening Nigeria's digital resilience.",
      "He serves as a Member of the National Steering Committee on the National Digital Trustmark Initiative, a flagship program of the National Information Technology Development Agency (NITDA) designed to promote trust, transparency, and accountability within Nigeria's digital economy.",
      "Olabode holds an M.Sc. in Computer Security and Forensics (Distinction) and a B.Sc. in Computer Science, both from reputable UK universities. He has further honed his executive leadership capabilities through advanced programs at Harvard University and the London Business School.",
      "A Certified Information Security Manager (CISM) and ISO 27001 Lead Implementer & Lead Auditor, he also holds certifications as an ISO 42001 Lead Implementer (AI Management System), Professional Scrum Master (PSM I), GDPR Data Protection Officer (GDPR-DPO), Check Point Certified Security Administrator (CCSA), Cisco Certified Network Associate (CCNA), and Microsoft Certified Technology Specialist (MCTS).",
      "Renowned for his thought leadership in cybersecurity and emerging technologies, Olabode continues to champion digital trust, AI governance, cybersecurity policy advancement, and responsible AI integration across Africa — fostering collaboration between government, industry, and academia in pursuit of a secure and inclusive digital future."
    ],
    email: 'president@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'M.Sc. in Computer Security and Forensics (Distinction)',
      'B.Sc. in Computer Science',
      'Certified Information Security Manager (CISM)',
      'ISO 27001 Lead Implementer & Lead Auditor',
      'ISO 42001 Lead Implementer (AI Management System)',
      'Professional Scrum Master (PSM I)',
      'GDPR Data Protection Officer (GDPR-DPO)'
    ],
    responsibilities: [
      'Oversee all association operations and strategic direction',
      'Serve as Member of National Steering Committee on Digital Trustmark Initiative',
      'Represent CSEAN at national and international forums',
      'Lead membership recruitment and retention initiatives'
    ],
    professionalHighlights: [
      'Serves as Member of National Steering Committee on NITDA\'s Digital Trustmark Initiative',
      'Executive leadership programs at Harvard University and London Business School',
      'Thought leadership in cybersecurity and emerging technologies'
    ]
  },
  {
    id: 'vice-president',
    name: 'Oluwatoni Falade',
    position: 'Vice President',
    image: '/images/OLUWATONI.jpeg',
    bio: [
      "OLUWATONI FALADE is a seasoned cybersecurity professional with over a decade of experience in cybersecurity management, information technology consulting, and project management. She is the Chief Executive Officer of Tochani Integrated Services Limited and currently serves as the Vice President of the Cyber Security Experts Association of Nigeria (CSEAN), where she leverages her expertise to drive innovation, build capacity, and strengthen cybersecurity initiatives across Nigeria.",
      "A results-driven leader, Oluwatoni has a proven track record of successfully managing complex IT and cybersecurity projects, facilitating high-impact training programs, and coordinating large-scale events that advance digital safety awareness. Her professional interests and expertise span IT project management, cybersecurity policy advocacy, research and data analysis, and human capacity development.",
      "In addition to her executive and leadership roles, Oluwatoni is the Founder of the Child Online Safety Network — an initiative dedicated to promoting digital literacy and protecting children from online risks.",
      "She is also a registered member of the Computer Professionals (Registration Council) of Nigeria (CPN), the Nigerian Computer Society (NCS), and the Nigerian Women in Information Technology (NIWIT). Through these professional affiliations, she actively supports initiatives that promote gender inclusion, mentorship, and leadership advancement for women in the fields of cybersecurity and information technology.",
      "Her professional pursuits reflect a strong commitment to advancing cybersecurity governance, digital rights protection, and human capacity development within Nigeria's evolving digital ecosystem."
    ],
    email: 'vp@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'IT Project Management',
      'Cybersecurity Management',
      'IT Consulting Certification'
    ],
    responsibilities: [
      'Support the President in day-to-day operations',
      'Drive innovation and build capacity',
      'Strengthen cybersecurity initiatives across Nigeria'
    ],
    professionalHighlights: [
      'Chief Executive Officer of Tochani Integrated Services Limited',
      'Founder of Child Online Safety Network',
      'Registered member of Computer Professionals (Registration Council) of Nigeria (CPN)'
    ]
  },
  {
    id: 'jonathan',
    name: 'Jonathan Ayodele',
    position: 'Director of Training and Education',
    image: '/images/Jonathan.jpeg',
    bio: [
      "Jonathan is the Director of Training and Education at the Cybersecurity Experts Association of Nigeria, with a career that spans roles as a Cybersecurity Engineer, Architect, Analyst, and Training Program Lead. He holds certifications such as ISO 27001 Lead Implementer, Security+, CCNA, CompTIA A+, Azure Security Engineer, Microsoft Cybersecurity Architect Expert, and is a member of the Cyber Security Experts Association of Nigeria, the British Computer Society, ISC2, ISACA, and the Chartered Institute of Information Security, London.",
      "His work extends beyond corporate environments into shaping the future of cybersecurity talent and building inclusive pathways into the industry.",
      "He currently serves as Early Careers Officer for the British Computer Society (UK), where he supports young professionals entering the technology field. Jonathan is also a dedicated mentor to global communities such as Blacks in Cybersecurity (USA) and Minorities in Cybersecurity (USA), helping underrepresented groups thrive in the industry. In Nigeria, he leads the Women in Cybersecurity Nigeria Mentorship Program, where he designs and oversees programs that provide technical and career guidance to aspiring women in cyber. His mentorship also extends to global initiatives, including the United Nations–backed Her-CyberTracks program, and regional platforms such as the CyberSafe Foundation and the Nexcascale Cloud Security BootCamp, both focused on building practical cyber skills for early-career professionals.",
      "Jonathan's passion for outreach also takes shape in the UK, where he has served as a STEM Ambassador, encouraging young learners to pursue technology careers, and as a trainer for the CyberFirst Girls competition, an initiative designed to spark interest in cybersecurity among secondary school girls. Beyond these, he contributes as Head of the Cybersecurity Program at the ThriveAfrica BootCamp in Ghana, equipping participants with practical cybersecurity skills to boost employability across the continent.",
      "Across these diverse initiatives, Jonathan has consistently demonstrated his commitment to developing the next generation of cybersecurity professionals, fostering inclusion, and bridging the global talent gap in cyber.",
      "He has received and been nominated for several awards, including the SME Africa 25 under 25 Awards, the UK Cyber Diversity Awards which he emerged \"Highly Commended\" in England, and recently the UK Real Cyber Awards."
    ],
    email: 'training@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'ISO 27001 Lead Implementer',
      'Security+',
      'CCNA',
      'CompTIA A+',
      'Azure Security Engineer',
      'Microsoft Cybersecurity Architect Expert'
    ],
    responsibilities: [
      'Develop and deliver comprehensive cybersecurity training programs',
      'Lead capacity building initiatives across Africa',
      'Mentor young professionals and underrepresented groups'
    ],
    professionalHighlights: [
      'Director of Training and Education at CSEAN',
      'Early Careers Officer for British Computer Society (UK)',
      'Mentor for Blacks in Cybersecurity (USA)'
    ]
  },
  {
    id: 'elizabeth',
    name: 'Elizabeth Mojisayo Adekunle',
    position: 'Director of Membership',
    image: '/images/Elizabeth.jpeg',
    bio: [
      "Elizabeth Mojisayo Adekunle is a seasoned membership relations professional with over 15 years of experience in member development, stakeholder engagement, and organizational growth within Nigeria's IT and professional sectors. A natural problem solver, she has led impactful initiatives that enhanced member retention, streamlined operations, and strengthened professional engagement nationwide. Known for creating beautiful membership experiences, Elizabeth is passionate about adding value, fostering meaningful connections, and ensuring every member's voice is heard and appreciated."
    ],
    email: 'membership@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'Member Development Certification',
      'Stakeholder Engagement Specialist',
      'Organizational Growth Management'
    ],
    responsibilities: [
      'Oversee member retention and growth strategies',
      'Enhance member experiences and value delivery',
      'Streamline membership operations and processes'
    ],
    professionalHighlights: [
      '15+ years in membership relations',
      'Known for creating beautiful membership experiences',
      'Expert in stakeholder engagement'
    ]
  },
  {
    id: 'olamide',
    name: 'Awobifa Olamide Seyi',
    position: 'Director of Information Security Development',
    image: '/images/Awobifa.jpeg',
    bio: [
      "Awobifa Olamide Seyi is a distinguished cybersecurity leader and technology strategist with over 15 years of progressive experience spanning cybersecurity engineering, governance, risk management, and cyber defense across the banking, fintech, media, energy, and consulting sectors.",
      "He holds a Higher National Diploma in Electrical/Electronic Engineering from The Polytechnic, Ibadan, a Bachelor's degree in Computer Science from Olabisi Onabanjo University, Ogun State, Nigeria, and a Postgraduate Diploma in Technology Entrepreneurship from the American University of Technology, USA.",
      "Olamide has held both technical and leadership positions in leading organizations including Oceanic Bank International Plc, Ecobank Nigeria, First Bank of Nigeria, Unity Bank, and SunTrust Bank. His professional journey also includes significant contributions within technology and consulting firms such as Cellulant Nigeria Limited, Computer Warehouse Group, NCR Nigeria Limited, Murhi International Group (MiTV/Star FM 101.5), AAA Bits Consulting, Royal Power & Energy Limited, Tomsecure Technologies Limited, CBC Netcomms, and Peniel Expert Solutions Ltd.",
      "With extensive experience across multiple cybersecurity domains, Olamide has directed enterprise-wide security programs, strengthened monitoring and detection capabilities, led vulnerability and threat management initiatives, overseen forensic investigations, and developed governance frameworks aligned with global standards such as ISO 27001, NIST CSF, COBIT, PCI-DSS, and NDPR.",
      "A results-oriented and people-focused leader, Olamide combines strong technical proficiency with business insight and strategic vision. He is passionate about mentoring cybersecurity professionals, fostering innovation, and integrating AI-driven automation and analytics to enhance organizational resilience and cyber maturity.",
      "He holds globally recognized certifications including CISA, CISM, CEH, alongside multiple vendor credentials from Fortinet, Forcepoint, Check Point, CISCO, Sophos, FireMon, Cyber Ark, Qualys, eScan, Bitdefender, Microsoft, Amazon, and Oracle.",
      "Olamide is a member of several professional cybersecurity communities, including ISACA, (ISC)² Nigeria, Compliance Institute Nigeria, Nigeria Computer Society, Nigerian Society of Engineer and International Association of Engineers.",
      "As the Director of Information Security Development at the Cyber Security Experts Association of Nigeria (CSEAN), Olamide leads initiatives that strengthen cybersecurity capacity building, research, and strategic collaboration across Africa. His vision is to cultivate innovations, integrity, and resilience while empowering professionals and securing Africa's digital future.",
      "When away from his cybersecurity workstations, Olamide finds creativity and balance through music. He enjoys playing the keyboard and guitar, reflecting his belief that harmony and precision are as vital in music as they are in cybersecurity. Olamide resides in Lagos, Nigeria, with his family."
    ],
    email: 'security@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'CISA (Certified Information Systems Auditor)',
      'CISM (Certified Information Security Manager)',
      'CEH (Certified Ethical Hacker)',
      'Graduate Electrical/Electronic Engineering'
    ],
    responsibilities: [
      'Lead information security development initiatives',
      'Provide expertise in Systems and Network Security',
      'Manage Cloud Security implementations'
    ],
    professionalHighlights: [
      'Over 15 years in cybersecurity across multiple sectors',
      'Worked with major banks including Ecobank, First Bank',
      'Co-founder of Tomsecure Technologies Limited'
    ]
  },
  {
    id: 'gabriel',
    name: 'Dr. Gabriel O. Akinremi',
    position: 'Director of Programme & ICT Lead',
    image: '/images/Gabriel.jpeg',
    bio: [
      "Gabriel O. Akinremi, PhD, is a cybersecurity, digital transformation, and ICT policy expert with over a decade of experience leading research, innovation, and capacity-building initiatives across West and Central Africa. He holds a PhD in Management Information Science, an MBA in Management Information Systems, an MSc in Cybersecurity from the Nigerian Defence Academy, and a Master of Information Technology from the University of Lagos, alongside certification in project management and numerous professional certifications in digital forensics, data protection, AI, cloud computing, cybersecurity and information management.",
      "He has worked with governments, civil society, academia, and multilateral organisations to strengthen cyber resilience, data protection, AI ethics, and digital rights. Currently serving as IT Lead at CLEEN Foundation, Programme Director at CSEAN, and Sessional Lecturer and Adjunct Faculty member at the University of America, FTL Africa, America Open University, he has also consulted for UNESCO on AI ethics, data governance, and cyber resilience.",
      "A multi-fellow of leading professional institutes across the world, Dr Akinremi is widely recognised for advancing digital inclusion, AI, cybersecurity, data protection, cyber policy, and secure technology adoption across Africa."
    ],
    email: 'programme@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'PhD in Management Information Science',
      'MBA in Management Information Systems',
      'MSc in Cybersecurity, Nigerian Defence Academy',
      'Master of Information Technology, University of Lagos'
    ],
    responsibilities: [
      'Lead programme development and implementation',
      'Serve as ICT Lead at CLEEN Foundation',
      'Direct CSEAN programme initiatives'
    ],
    professionalHighlights: [
      'IT Lead at CLEEN Foundation',
      'Programme Director at CSEAN',
      'UNESCO consultant on AI ethics and cyber resilience'
    ]
  },
  {
    id: 'bube',
    name: 'C.itp Muntaka Mukhtar Bube',
    position: 'Director of Communications',
    image: '/images/Muntaka.jpeg',
    bio: [
      "C.itp Muntaka Mukhtar Bube mcpn, mncs, mispon, mcsean - Director of Communications. Bube is a chartered information technology professional, seasoned software developer, technology entrepreneur, and cybersecurity evangelist with over 19 years of progressive experience in the Information Technology industry. He has played a leading role in the design, development, and deployment of enterprise-grade software and security applications that drive innovation and digital transformation.",
      "His journey reflects a remarkable story of growth, dedication, and innovation—rising from the position of a Computer Operator to Chief Software Developer. He is widely recognized for his expertise in system architecture, software engineering, and digital transformation, as well as for his leadership in capacity building within Nigeria's IT ecosystem.",
      "Furthermore, he is a professional teacher, mentor, and digital skills trainer, dedicated to nurturing the next generation of technology leaders and cybersecurity professionals. His mission continues to bridge the gap between innovation, security, and digital empowerment across communities and institutions.",
      "He is a member of several professional bodies, including the Computer Professionals (Registration Council of Nigeria) – MCPN, the Nigeria Computer Society (NCS), the Institute of Software Practitioners of Nigeria (ISPON), and the Cyber Security Experts Association of Nigeria (CSEAN)."
    ],
    email: 'communications@csean.org.ng',
    linkedin: '#',
    twitter: '#',
    qualifications: [
      'Chartered Information Technology Professional (C.itp)',
      'Member of Computer Professionals Registration Council of Nigeria (MCPN)',
      'Member of Nigeria Computer Society (MNCS)',
      'Member of Institute of Software Practitioners of Nigeria (MISPON)'
    ],
    responsibilities: [
      'Lead communications and public awareness initiatives',
      'Drive digital transformation and innovation',
      'Develop secure, scalable enterprise systems'
    ],
    professionalHighlights: [
      '19 years of progressive experience in IT industry',
      'Chief Software Developer at Usmanu Danfodiyo University',
      'Expert in system architecture and software engineering'
    ]
  },
  {
    id: 'adamu',
    name: 'Adamu Jibrin',
    position: 'Director of Research and Development',
    image: '/images/ADAMU.jpeg',
    bio: 'Adamu Jibrin serves as Director of Research and Development at the Cyber Security Experts Association of Nigeria.',
    qualifications: [],
    responsibilities: [],
    professionalHighlights: []
  }
];
